import { render, staticRenderFns } from "./CustomerIdentification.vue?vue&type=template&id=063f5f09&scoped=true&"
import script from "./CustomerIdentification.vue?vue&type=script&lang=js&"
export * from "./CustomerIdentification.vue?vue&type=script&lang=js&"
import style0 from "./CustomerIdentification.vue?vue&type=style&index=0&id=063f5f09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f5f09",
  null
  
)

export default component.exports